import React, { FunctionComponent } from "react";
import { Typography, Grid } from "@material-ui/core";
import packageJson from '../../package.json';
export const Footer: FunctionComponent = () => {
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item style={{position:"fixed",bottom:0,backgroundColor:"#fff"}}>
        <Typography color="primary">Powered by ffcpos v.{packageJson.version}</Typography>
      </Grid>
    </Grid>
  );
};
